import http from "@/common/services/http.js";

export default {
    async getWxInfo() {
        return await http.get('/wechat/pay/userinfo');
    },

    // 获取项目列表
    async getProjectList(params) {
        return await http.get('/pay/projects', {
            queryParam: params
        });
    },

    // 获取房间列表
    async getRoomList(params) {
        return await http.get('/pay/rooms', {
            queryParam: params
        });
    },

    async getRoomListSimple(params) {
        return await http.get('/pay/rooms_simple', {
            queryParam: params
        });
    },

    async getWarningInfo() {
        return await http.get('/pay/alarm_rooms');
    },
};
